import React, { useState } from 'react';
import './MessageBubble.css';

const MessageBubble = ({ message, isOwnMessage, showTime, formatTime }) => {
  const [showActions, setShowActions] = useState(false);

  const getSenderName = () => {
    if (message.sender?.email) {
      // Extract name from email or use email as fallback
      const email = message.sender.email;
      if (email.includes('@')) {
        return email.split('@')[0];
      }
      return email;
    }
    return '未知用戶';
  };

  const getSenderRole = () => {
    if (message.sender?.role) {
      const roleMap = {
        'admin': '管理員',
        'staff': '職員',
        'teacher': '教師',
        'student': '學生',
        'parent': '家長'
      };
      return roleMap[message.sender.role] || message.sender.role;
    }
    return '';
  };

  const getMessageStatus = () => {
    // This would be implemented with actual message status logic
    if (isOwnMessage) {
      return '✓✓'; // Read receipts
    }
    return null;
  };

  const handleMessageActions = (action) => {
    switch (action) {
      case 'reply':
        console.log('Reply to message:', message.id);
        break;
      case 'forward':
        console.log('Forward message:', message.id);
        break;
      case 'edit':
        console.log('Edit message:', message.id);
        break;
      case 'delete':
        console.log('Delete message:', message.id);
        break;
      default:
        break;
    }
    setShowActions(false);
  };

  const renderMessageContent = () => {
    switch (message.message_type) {
      case 'text':
        return (
          <div className="message-text">
            {message.content}
          </div>
        );
      
      case 'image':
        return (
          <div className="message-image">
            <img 
              src={message.attachments?.[0]?.file_url || message.content} 
              alt="Image message"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="image-fallback" style={{ display: 'none' }}>
              🖼️ 圖片無法載入
            </div>
          </div>
        );
      
      case 'file':
        return (
          <div className="message-file">
            <div className="file-icon">📎</div>
            <div className="file-info">
              <div className="file-name">{message.attachments?.[0]?.original_name || '檔案'}</div>
              <div className="file-size">
                {message.attachments?.[0]?.file_size 
                  ? `${(message.attachments[0].file_size / 1024).toFixed(1)} KB`
                  : '未知大小'
                }
              </div>
            </div>
            <button className="btn-download" title="下載檔案">
              ⬇️
            </button>
          </div>
        );
      
      case 'system':
        return (
          <div className="message-system">
            <div className="system-icon">🔔</div>
            <div className="system-content">{message.content}</div>
          </div>
        );
      
      default:
        return (
          <div className="message-text">
            {message.content}
          </div>
        );
    }
  };

  const renderAttachments = () => {
    if (!message.attachments || message.attachments.length === 0) return null;

    return (
      <div className="message-attachments">
        {message.attachments.map((attachment, index) => (
          <div key={index} className="attachment-item">
            {attachment.file_type === 'image' ? (
              <img 
                src={attachment.file_url} 
                alt={attachment.original_name}
                className="attachment-image"
              />
            ) : (
              <div className="attachment-file">
                <span className="file-icon">📎</span>
                <span className="file-name">{attachment.original_name}</span>
                <span className="file-size">
                  {(attachment.file_size / 1024).toFixed(1)} KB
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div 
      className={`message-bubble ${isOwnMessage ? 'own-message' : 'other-message'}`}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      {!isOwnMessage && (
        <div className="message-sender">
          <div className="sender-avatar">
            {getSenderName().charAt(0).toUpperCase()}
          </div>
          <div className="sender-info">
            <span className="sender-name">{getSenderName()}</span>
            {getSenderRole() && (
              <span className="sender-role">({getSenderRole()})</span>
            )}
          </div>
        </div>
      )}

      <div className="message-content">
        {renderMessageContent()}
        {renderAttachments()}
        
        <div className="message-meta">
          <span className="message-time">
            {formatTime ? formatTime(message.created_at) : 
              new Date(message.created_at).toLocaleTimeString('zh-TW', {
                hour: '2-digit',
                minute: '2-digit'
              })
            }
          </span>
          
          {isOwnMessage && (
            <span className="message-status">
              {getMessageStatus()}
            </span>
          )}
        </div>
      </div>

      {/* Message Actions */}
      {showActions && (
        <div className="message-actions">
          <button 
            className="action-btn"
            onClick={() => handleMessageActions('reply')}
            title="回覆"
          >
            💬
          </button>
          
          <button 
            className="action-btn"
            onClick={() => handleMessageActions('forward')}
            title="轉發"
          >
            ➡️
          </button>
          
          {isOwnMessage && (
            <>
              <button 
                className="action-btn"
                onClick={() => handleMessageActions('edit')}
                title="編輯"
              >
                ✏️
              </button>
              
              <button 
                className="action-btn"
                onClick={() => handleMessageActions('delete')}
                title="刪除"
              >
                🗑️
              </button>
            </>
          )}
        </div>
      )}

      {/* Reply indicator */}
      {message.reply_to_id && (
        <div className="reply-indicator">
          <span className="reply-icon">↩️</span>
          <span className="reply-text">回覆訊息</span>
        </div>
      )}
    </div>
  );
};

export default MessageBubble;
